// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
import Popper from "popper.js";

window.jQuery = $;
window.$ = $;

require("bootstrap");
require("owl.carousel");
require('jquery.waitforimages');

$(function () {
  $('.search-open').on('click', () => {
    $('.search-form').addClass('d-flex').fadeIn();

  });

  $('.search-close').on('click', () => {
    $('.search-form').removeClass('d-flex').fadeOut();
  });

  $('.offcanvas').on('show.bs.collapse', () => {
    $('.offcanvas-overlay').addClass('show');
  });

  $('.offcanvas').on('hide.bs.collapse', () => {
    $('.offcanvas-overlay').removeClass('show');
  });

  let awardsOwl = $('.awards-carousel');

  let $awardsCount = $('.awards-carousel a').length;

  awardsOwl.owlCarousel({
    loop: true,
    responsive: {
      0: {
        items: 1.6,
        center: true,
        dots: true,
      },
      992: {
        items: 2,
        dots: false,
      },
      1200: {
        items: $awardsCount > 2 ? 3 : $awardsCount,
        dots: false,
      }
    }
  });

  $('.awardsNextBtn').click(function () {
    awardsOwl.trigger('next.owl.carousel');
  });
  $('.awardsPrevBtn').click(function () {
    awardsOwl.trigger('prev.owl.carousel');
  });

  let halfOwl = $('.half-carousel');

  halfOwl.waitForImages(() => {
    halfOwl.owlCarousel({
      margin: 10,
      stagePadding: 50,
      responsive: {
        0: {
          items: 1,
          center: true,
          autoWidth: true,
        },
        992: {
          items: 2,
          dots: false,
          navs: true,
          loop: true,
          autoWidth: true,
        }
      }
    });
  });

  $('.halfNextBtn').click(function () {
    halfOwl.trigger('next.owl.carousel');
  });
  $('.halfPrevBtn').click(function () {
    halfOwl.trigger('prev.owl.carousel');
  });

  let fullOwl = $('.full-carousel');
  fullOwl.owlCarousel({
    // autoWidth: true,
    items: 1.3,
    center: true,
    responsive: {
      992: {
        dots: false,
        navs: true,
      }
    }
  });

  $('.fullNextBtn').click(function () {
    fullOwl.trigger('next.owl.carousel');
  });
  $('.fullPrevBtn').click(function () {
    fullOwl.trigger('prev.owl.carousel');
  });

  $('#accordionProud').on('show.bs.collapse', (e) => {
    console.log($(e.target).attr('id'));
    $('.proud-of .proud-images img').fadeOut().promise().done(() => {
      $('.proud-of .proud-images img[data-collapse-open="' + $(e.target).attr('id') + '"]').fadeIn();
    });
  });

  $('.mobil-carousel').owlCarousel({
    margin: 10,
    items: 1.1,
    center: true,
  });

  let historyOwl = $('.history-carousel');

  historyOwl.owlCarousel({
    items: 1,
    dots: false,
  });

  $('.historyNextBtn').click(function () {
    historyOwl.trigger('next.owl.carousel');
  });

  $('.historyPrevBtn').click(function () {
    historyOwl.trigger('prev.owl.carousel');
  });

  $(document).on('scroll', () => {
    if ($('.alert-warning').length > 0) {
      let height = window.innerHeight;
      if (window.scrollY > $('.alert-warning').offset().top + 60) {
        $('.btn-tofixed').addClass('isFixed');
      } else if (window.scrollY < $('.alert-warning').offset().top) {
        $('.btn-tofixed').removeClass('isFixed');
      }
    }
  });

  $(document).on('change', '.regform input[type=text], .regform input[type=password], .form-horizontal input[type=text], .form-horizontal input[type=password]', event => $(event.currentTarget).attr('value', $(event.currentTarget).val()));

  $(document).on('change', '.regform textarea, .form-horizontal textarea', event => {
    $(event.currentTarget).html($(event.currentTarget).val());
  });
  
  $(document).on('click', '.apply-scroll', e => {
      e.preventDefault();
      if ($('#apply-title').length) {
          $('body, html').animate({scrollTop: $('#apply-title').offset().top - 50});
      } else {
          $('body, html').animate({scrollTop: $('#project-apply').offset().top - 50});
      }
  });
});
